/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

const matchesRegister = (obisCode, prefix, tariffBased = false) => {
  if (typeof obisCode !== 'string') {
    return false;
  }

  const match = obisCode.match(new RegExp(`^${prefix}\\.(\\d+)(?:[_*].*)?$`));
  if (!match) {
    return false;
  }

  const registerIndex = Number(match[1]);
  return tariffBased ? registerIndex > 0 : registerIndex === 0;
};

export const getVisibleCards = (registers) => {
  if (!Array.isArray(registers) || registers.length === 0) {
    return [];
  }

  const obisCodes = registers.flatMap((register) =>
    Array.isArray(register?.obisCodes) ? register.obisCodes : [],
  );
  const hasMaxDemand = obisCodes.some((code) => matchesRegister(code, '9\\.6'));
  const hasActiveImport = obisCodes.some((code) =>
    matchesRegister(code, '1\\.8', true),
  );
  const hasActiveExport = obisCodes.some((code) =>
    matchesRegister(code, '2\\.8', true),
  );
  const cards = [];

  if (hasActiveImport) {
    cards.push(hasMaxDemand ? 'BULK_IMPORT' : 'ACTIVE_IMPORT');
  } else if (obisCodes.some((code) => matchesRegister(code, '1\\.8'))) {
    cards.push('TOTAL_IMPORT');
  }

  if (hasActiveExport) {
    cards.push(hasMaxDemand ? 'BULK_EXPORT' : 'ACTIVE_EXPORT');
  } else if (obisCodes.some((code) => matchesRegister(code, '2\\.8'))) {
    cards.push('TOTAL_EXPORT');
  }

  return cards;
};
